module.exports = __webpack_public_path__ + "static/media/lp_ic_arrow_down.63c0cd95.svg";